export function deepEqual(x: any, y: any): boolean {
  const typeX = typeof x
  const typeY = typeof y

  if (x && y && typeX === 'object' && typeX === typeY) {
    const keys = Object.keys(x)

    return keys.length === Object.keys(y).length && keys.every(key => deepEqual(x[key], y[key]))
  }

  return x === y
}

export function arrayDeepEquals(x: any[], y: any[]): boolean {
  if (x.length !== y.length) {
    return false
  }
  for (let i = 0; i < x.length; i += 1) {
    if (!deepEqual(x[i], y[i])) {
      return false
    }
  }

  return true
}
export function inactiveMin() {
  if (typeof window === 'undefined') {
    return 0
  }
  const { lastAction } = window.ROGUE

  if (lastAction) {
    return Math.floor((Date.now() - lastAction) / (1000 * 60))
  }

  return 0
}

export function sessionDurationMin() {
  if (typeof window === 'undefined') {
    return 0
  }
  const { sessionStart } = window.ROGUE
  if (sessionStart) {
    return Math.floor((Date.now() - sessionStart) / (1000 * 60))
  }

  return 0
}

export function setCookie(cName:string, cValue: string, expDays: number = 365) {
  if (typeof window === 'undefined') {
    return
  }
  let expires = ''
  if (expDays > 0) {
    const date = new Date()
    date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000))
    expires = `expires=${date.toUTCString()};`
  }
  try {
    document.cookie = `${cName}=${cValue};${expires} path=/`
  } catch (e) {
    console.debug('Error setting cookie', e)
  }
}

export function getCookie(cName: string): string | null {
  if (typeof window === 'undefined') {
    return null
  }
  const name = `${cName}=`
  let res = null
  try {
    const cDecoded = decodeURIComponent(document.cookie) // to be careful
    const cArr = cDecoded.split('; ')
    cArr.forEach(val => {
      if (val.indexOf(name) === 0) {
        res = val.substring(name.length)
      }
    })
  } catch (e) {
    console.debug('Error getting cookie', e)
  }

  return res
}

/**
 * We can use Local Storage to tell if another tab is open to RF.com, since local storage is shared
 * across tabs
 * We add a listener for localstorage events to respond to OTHER tabs that ask if we are open
 * Then we ask if anyone else is listening and wait for 50ms
 * If nobody responds, we are the only tab.
 */
export async function checkIfAnotherTabOpen() {
  return new Promise(resolve => {
    // We dont want to resolve multiple times, so we track the first time we resolve
    let resolved = false

    try {
    // Listen for storage events
      window.addEventListener('storage', e => {
        if (e.key === 'openpages') {
        // Some other tab asked if we are open. Respond by updating the date
          localStorage.page_available = Date.now()
        }
        // If this fires, it means some other tab has notified the browser that it is open
        if (e.key === 'page_available') {
          if (!resolved) {
            resolved = true
            // Resolve that another tab IS open
            resolve(true)
          }
        }
      }, false)

      // Broadcast that we are open
      localStorage.openpages = Date.now()

      // If the listener hasn't responded in 25ms, we are the only tab
      setTimeout(() => {
        resolved = true
        resolve(false)
      }, 25)
    } catch (e) {
      // Local storage not enabled

      resolved = true
      resolve(false)
    }
  })
}
